import * as actions from './actions';
import * as getters from './getters';
import * as mutations from './mutations';
import { TFTSMonthlyState } from './types';

export default {
  namespaced: true,
  getters,
  mutations,
  actions,
  state: {
    tableData: {
      items: [],
      periods: [],
      firstItemNumber: 1,
      itemCount: 1,
      itemsTotal: 1,
      pageNumber: 1,
      pageSize: 10,
      pagesTotal: 1,
    },
  } as TFTSMonthlyState,
};
